// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js","774":"framework"}[chunkId] || chunkId) + "-" + {"217":"52a4dc31a9ff185f9237","532":"99672981795d8c2aca4e","678":"96a55b3bd98178388c04","774":"460167880b492b0fb494","932":"712915ff7bbba45cd37c"}[chunkId] + ".js";
};